import { userRolesMap } from '@clatter/platform';

export * from './services';
export * from './acl';

export const globalAdminRoles = [userRolesMap.ngAdmin, userRolesMap.systemAdmin, userRolesMap.clatterAdmin];

export const pagesMap = {
  workspaceTemplates: {
    slug: 'workspace-templates',
    displayName: 'Workspace Templates',
    accessRoles: [...globalAdminRoles, userRolesMap.ngContentManager],
  },
  entities: {
    slug: 'entities',
    displayName: 'Entities',
    accessRoles: [...globalAdminRoles, userRolesMap.ngContentManager],
  },
  categories: {
    slug: 'categories',
    displayName: 'Categories',
    documentTitle: 'Categories',
    accessRoles: [...globalAdminRoles, userRolesMap.ngContentManager],
  },
  users: {
    slug: 'users',
    displayName: 'Manage Users',
    accessRoles: globalAdminRoles,
  },
  groups: {
    slug: 'groups',
    displayName: 'Manage Groups',
    accessRoles: globalAdminRoles,
  },
  slidespaces: {
    slug: 'slidespaces',
    displayName: 'Slidespaces',
    accessRoles: [...globalAdminRoles, userRolesMap.ngContentManager],
  },
  settings: {
    slug: 'settings',
    displayName: 'System Config',
    accessRoles: globalAdminRoles,
  },
  reports: {
    slug: 'reports',
    displayName: 'Reports',
    accessRoles: globalAdminRoles,
  },
};

export const listActionTypes = {
  MOVE_UP: 'MOVE_UP',
  MOVE_DOWN: 'MOVE_DOWN',
  REMOVE: 'REMOVE',
  OPEN_SETTINGS: 'OPEN_SETTINGS',
};

export const projectPagesMap = {
  QUERY: {
    displayName: 'Query',
    slug: 'query',
  },
  QUERIES: {
    displayName: 'Queries',
    slug: 'queries',
  },
  DATA: {
    displayName: 'Data',
    slug: 'data',
  },
  DOCUMENTS: {
    displayName: 'Documents',
    slug: 'documents',
  },
  UPLOADED_DATA: {
    displayName: 'Uploaded Data',
    slug: 'data-uploaded',
  },
  ENTITIES: {
    displayName: 'Entities',
    slug: 'entities',
  },
  VALUES: {
    displayName: 'Values',
    slug: 'values',
  },
  ETL: {
    displayName: 'Etl',
    slug: 'etl',
  },
  TEMPLATES: {
    displayName: 'Templates',
    slug: 'templates',
  },
  WORKSPACE_SETTINGS: {
    displayName: 'Settings',
    slug: 'settings',
  },
  BLOCKS: {
    displayName: 'Blocks',
    slug: 'blocks',
  },
  MICROSITE: {
    displayName: 'My Site',
    slug: 'my-site',
  },
  PLACEMAT_GENERATOR: {
    displayName: 'Placemat',
    slug: 'placemat',
  },
};

export enum GrantAccessLevel {
  EDITOR = 'editor',
  VIEWER = 'viewer',
  DATA_ADMIN = 'data-admin',
}

export const GrantAccessLevelToDisplayNameMap = {
  [GrantAccessLevel.VIEWER]: 'Viewer',
  [GrantAccessLevel.EDITOR]: 'Editor',
  [GrantAccessLevel.DATA_ADMIN]: 'Data Admin',
};

export enum GrantResourceType {
  PROJECTS = 'projects',
  SLIDE_REPOSITORIES = 'slide-repositories',
  FOLDERS = 'folders',
}

export const GrantResourceTypeToDisplayNameMap: Record<GrantResourceType, string> = {
  [GrantResourceType.PROJECTS]: 'Workspace',
  [GrantResourceType.SLIDE_REPOSITORIES]: 'Slidespace',
  [GrantResourceType.FOLDERS]: 'Folder',
};
